module.exports = __webpack_public_path__ + "static/img/telegram-modal-guide-img.c722523.jpg";